<template>
    <div>
      <router-view />
    </div>
  </template>
  <script>
  
  export default {
    name: "FluxMasterSKU",
    data () {
      return {}
    },
    created () {
  
    },
    methods: {
    
    },
  }
  
  </script>
  